// extracted by mini-css-extract-plugin
module.exports = {"sideMenu":"_1XKbYK"};